/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.DeclareContractResponseDto>>;
export function request(
  params: API.tms.declareContract.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/declareContract/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
